/**
 * File baguetteBox-customization.js.
 */

(function () {
	window.addEventListener("load", function() {
		baguetteBox.run(".wp-block-gallery,:not(.wp-block-gallery)>.wp-block-image,.wp-block-media-text__media,.gallery,.wp-block-coblocks-gallery-masonry,.wp-block-coblocks-gallery-stacked,.wp-block-coblocks-gallery-collage,.wp-block-coblocks-gallery-offset,.wp-block-coblocks-gallery-stacked", {
			leftArrow: `
                <svg aria-hidden="true" role="img" focusable="false" class="svg-icon svg--fill-path" xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12" fill="none">
                    <path d="M.2 5.5c-.3.3-.3.8 0 1.1L5 11.3c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1L1.8 6 6 1.8c.3-.3.3-.8 0-1.1-.2-.3-.7-.3-1 0L.2 5.5zm14.5-.2H.7v1.5h14V5.3z" fill="#fff"></path>
                </svg>`,
			rightArrow: `
                <svg aria-hidden="true" role="img" focusable="false" class="svg-icon svg--fill-path" xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12" fill="none">
                    <path d="M14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.6967C9.46447 0.403807 8.98959 0.403807 8.6967 0.6967C8.40381 0.989593 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM-6.55671e-08 6.75L14 6.75L14 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path>
                </svg>`,
			closeX: `
                <svg aria-hidden="true" width="30" height="30" fill="none" viewBox="0 0 24 24" class="svg-icon svg--stroke-path" stroke="darkorange">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.34" d="M6 18L18 6M6 6l12 12"/>
                </svg>`,
			overlayBackgroundColor: "rgba(var(--crafted--color-theme-bg-rgb), 0.98)",
			captions: function(t) {
				var e = t.parentElement.classList.contains("wp-block-image") || t.parentElement.classList.contains("wp-block-media-text__media") ? t.parentElement.querySelector("figcaption") : t.parentElement.parentElement.querySelector("figcaption,dd");
				return !!e && e.innerHTML;
			},
			filter: /.+\.(gif|jpe?g|png|webp|svg|avif|heif|heic|tif?f|)($|\?)/i,
			noScrollbars: true
		});
	});
})();

